var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5583_16610)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14775 0.352252C0.928078 0.132583 0.571922 0.132583 0.352252 0.352252C0.132583 0.571922 0.132583 0.928078 0.352252 1.14775L2.19018 2.98567C1.30195 3.70995 0.597791 4.6791 0.153025 5.79102C0.0993823 5.92513 0.0993823 6.07473 0.153025 6.20883C1.12514 8.63911 3.33642 10.3874 6.00029 10.3874C7.03752 10.3874 8.00614 10.1224 8.8597 9.6552L10.8523 11.6477C11.0719 11.8674 11.4281 11.8674 11.6477 11.6477C11.8674 11.4281 11.8674 11.0719 11.6477 10.8523L9.81001 9.01451C10.6984 8.2902 11.4027 7.32092 11.8476 6.20883C11.9012 6.07473 11.9012 5.92513 11.8476 5.79102C10.8755 3.36074 8.66416 1.61243 6.00029 1.61243C4.96287 1.61243 3.99409 1.87758 3.14041 2.34492L1.14775 0.352252ZM2.99052 3.78602C2.27047 4.34628 1.6816 5.10538 1.28555 5.99993C2.15091 7.9545 3.93684 9.26243 6.00029 9.26243C6.71654 9.26243 7.39935 9.10484 8.02183 8.81732L7.132 7.9275C6.78148 8.13345 6.36144 8.21251 5.99985 8.21251C4.78919 8.21251 3.78735 7.21067 3.78735 6.00001C3.78735 5.61439 3.90528 5.22358 4.10661 4.90211L2.99052 3.78602ZM9.00965 8.21416L3.97826 3.18276C4.60087 2.8951 5.28385 2.73743 6.00029 2.73743C8.06375 2.73743 9.84968 4.04536 10.715 5.99993C10.3189 6.89464 9.72989 7.65386 9.00965 8.21416ZM4.94656 5.75797C4.92503 5.83516 4.91235 5.91705 4.91235 6.00001C4.91235 6.58935 5.41051 7.08751 5.99985 7.08751C6.07851 7.08751 6.15121 7.08161 6.2176 7.07138L4.94656 5.75797Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5583_16610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenStatus);
export default __webpack_public_path__ + "static/media/hidden-status.d4ca2861846244462fe681126699b666.svg";
export { ForwardRef as ReactComponent };